<ng-container *ngIf="cart$ | async as cart">
  <ng-container *ngIf="entries$ | async as entries">
    <h4 class="order-summary-title">{{ 'cart.orderSummary.title' | cxTranslate }}</h4>

    <div class="order-summary-wrapper">
      <cx-order-summary
        [ngClass]="snahBordersDisplay(showActiveSnahCountry | async)"
        [cart]="cart"
        [pageId]="pageId"
        [promotions]="cart.potentialOrderPromotions"
      ></cx-order-summary>
      <hr />
      <cx-cart-coupon *ngIf="pagetemplate == cartPageId"></cx-cart-coupon>
      <!-- start Potential Promotion + applied promotion  -->
      <app-potential-promotions
        [potentialPromotions]="cart.potentialOrderPromotions"
        [showSrp]="showSrp"
        [promotionLocation]="pageId"
      ></app-potential-promotions>
      <!-- end Potential Promotion + applied promotion  -->
      <div class="order-summary-action" *ngIf="pagetemplate == cartPageId">
        <button
          *ngIf="entries.length && checkoutAllowed"
          class="primary-btn btn-block btn"
          [class.disabled]="isDisabledCheckout(showSrp, cart['validated'])"
          type="button"
          [disabled]="isDisabledCheckout(showSrp, cart['validated'])"
          (click)="onCheckout(cart.code, cart?.paymentAddress?.addressId, cart?.paymentAddress?.formattedAddress, cart)"
        >
          {{ 'cart.cartAction.checkout' | cxTranslate }}
        </button>
        <button
          class="secondary-btn btn-block btn"
          [class.disabled]="showSrp"
          type="button"
          (click)="saveCartModal(cart)"
          [disabled]="showSrp"
        >
          {{ 'cart.cartAction.savecart' | cxTranslate }}
        </button>
        <button [routerLink]="{ cxRoute: 'home' } | cxUrl" class="tertiary-btn btn-block btn mt-3 mb-2" type="button">
          {{ 'cart.cartAction.continue' | cxTranslate }}
        </button>
        <div class="srp-toggle-info text-center mt-2 mb-1" *ngIf="showSrp">
          <span>{{ 'cart.srpMessageCart' | cxTranslate }}</span>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
